if (!customElements.get('product-form')) {
	customElements.define('product-form', class ProductForm extends HTMLElement {
		constructor() {
			super();

			this.form = this.querySelector('form');
			this.form.querySelector('[name=id]').disabled = false;
			this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
			this.minicart = document.querySelector('mini-cart');
			this.eventContext = this.form.dataset.eventContext;
			this.hideErrors = this.dataset.hideErrors === 'true';
		}

		onSubmitHandler(event) {
			event.preventDefault();       
          console.log('aaaaaa')
			const submitButton = this.querySelector('[type="submit"]');
			if (submitButton.classList.contains('loading')) {
				return;
			}

			this.handleErrorMessage();

			submitButton.setAttribute('aria-disabled', true);
			submitButton.classList.add('loading');
            jQuery('button.button.button-secondary.button-add-to-cart.button-solid').prop("disabled", true);
			this.querySelector('.button-overlay-spinner').classList.remove('hidden');

			const config = fetchConfig('javascript');
			config.headers['X-Requested-With'] = 'XMLHttpRequest';
			delete config.headers['Content-Type'];

			const formData = new FormData(this.form);
			formData.append('sections', this.minicart.getSectionsToRender().map((section) => section.id));
			formData.append('sections_url', window.location.pathname);
			config.body = formData;
          var additionalproductquantity = 1;
          var additionalCharges = formData.get("additional_charges"); // Get the value
          
          var additionalChargesquantity = formData.get("quantity");
          if(additionalChargesquantity !== null && additionalChargesquantity !== ''){
            additionalproductquantity = additionalChargesquantity;
          }

          // Drilling Charges
          var drillingproductquantity = 1;
          var drillingCharges = formData.get("drilling_charges"); // Get the value
          
          var drillingChargesquantity = formData.get("quantity");
          if(drillingChargesquantity !== null && drillingChargesquantity !== ''){
            drillingproductquantity = drillingChargesquantity;
          }
			fetch(`${routes.cart_add_url}`, config)
				.then((response) => response.json())
				.then((response) => {
                  //console.log('=====response.status====',response)
					if (response.status) {
						publish(PUB_SUB_EVENTS.cartError, {
							source: 'product-form',
							productVariantId: formData.get('id'),
							errors: response.errors || response.description,
							message: response.message,
						});

						this.handleErrorMessage(response.description);
						this.minicart.updateSectionContents();
						return;
					}

          // If Drilling charges product should be added
          if (drillingCharges === 'yes') {
						let drillingProductId = 44403212189836;

						fetch('/cart/add.js', {
							method: 'POST',
							headers: { 'Content-Type': 'application/json' },
							body: JSON.stringify({ id: drillingProductId, quantity: drillingproductquantity })
						})
						.then(response => response.json())
						.then(data => {
							//console.log("Additional Product Added:", data);
							this.updateMiniCart(); // ✅ Update mini-cart after both products are added
							this.finalizeCartUpdate(submitButton, response);
						})
						.catch(error => console.error("Error adding additional product:", error));

					}
					// If additional charges product should be added
					if (additionalCharges === 'yes') {
						let additionalProductId = 43976061780108;

						fetch('/cart/add.js', {
							method: 'POST',
							headers: { 'Content-Type': 'application/json' },
							body: JSON.stringify({ id: additionalProductId, quantity: additionalproductquantity })
						})
						.then(response => response.json())
						.then(data => {
							//console.log("Additional Product Added:", data);
							this.updateMiniCart(); // ✅ Update mini-cart after both products are added
							this.finalizeCartUpdate(submitButton, response);
						})
						.catch(error => console.error("Error adding additional product:", error));

					} else {
						 this.minicart.renderContents(response);
    					if (window.themeSettings.redirectToCart) {
    						location.href = '/cart';
    					} else {
    						this.minicart.open(submitButton);
    					}
					}

					publish(PUB_SUB_EVENTS.cartItemAdd, {
						source: this.eventContext,
						items: [response],
					});
				})
				.catch((e) => {
					console.error(e);
				})
				.finally(() => {
					submitButton.classList.remove('loading');
					submitButton.removeAttribute('aria-disabled');
                  jQuery('button.button.button-secondary.button-add-to-cart.button-solid').prop("disabled", false);
					this.querySelector('.button-overlay-spinner').classList.add('hidden');
				});
		}
      // ✅ Function to Update Mini-Cart Without Reloading
		updateMiniCart() {
           fetch('/cart.js')
            .then(response => response.json()) // Parse JSON response
            .then(cart => {
                // Update cart item count
                document.querySelector("span.head-slot-cart-link-quantity").innerText = cart.item_count;
            })
            .catch(error => console.error("Error updating cart count:", error));

			fetch(window.location.href)
				.then(response => response.text())
				.then(html => {
					let parser = new DOMParser();
					let doc = parser.parseFromString(html, "text/html");
					let newMiniCart = doc.querySelector(".mini-cart-wrap");
					let currentMiniCart = document.querySelector(".mini-cart-wrap");

					if (newMiniCart && currentMiniCart) {
						currentMiniCart.innerHTML = newMiniCart.innerHTML;
					}
				})
				.catch(error => console.error("Error updating mini-cart:", error));
		}

		// ✅ Function to Finalize Cart Update
		finalizeCartUpdate(submitButton, response) {
			this.minicart.renderContents(response);

			if (window.themeSettings.redirectToCart) {
				location.href = '/cart';
			} else {
				this.minicart.open(submitButton);
			}
		}
		handleErrorMessage(errorMessage = false) {
			if (this.hideErrors) {
				return;
			}

			this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form-error-message-wrapper');
			this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form-error-message');

			this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

			if (errorMessage) {
				this.errorMessage.textContent = errorMessage;
			}
		}
	});
}
// document.addEventListener("focusout", function (event) {
//     if (event.target.classList.contains("cart-quantity-input-field")) {
//        setTimeout(function () {
//         getCartProducts();
//        }, 2000);
//     }
// });
// document.addEventListener("click", function (event) {
//   let removeButton = event.target.closest(".cart-button-cart-remove");  
//     if (
//         event.target.matches(".cart-quantity-input-button") ||
//         event.target.matches("a.button-cart-remove") ||    
//         event.target.matches(".mini-cart-item-remove")
//     ) {
//         event.preventDefault();
//     setTimeout(function () {
//       getCartProducts();
//      }, 2000);
//     } else if (removeButton){
//       if(removeButton.matches(".cart-button-cart-remove")){
//          event.preventDefault();
//           setTimeout(function () {
//             getCartProducts();
//            }, 2000);
//       }
//     } else if( event.target.matches(".button-drawer-header-dismiss.dropdown-modal-toggle")){
//        let miniCartModal = document.getElementById("HeaderMiniCart");
//             if (miniCartModal) {
//                 miniCartModal.removeAttribute("open");
//             }
//       let cartToggle = document.querySelector("a.head-slot-cart-link.dropdown-modal-toggle");
//         if (cartToggle) {
//             cartToggle.removeAttribute("aria-expanded");
//         }
//     }
// });

// close drawer when product added
jQuery(document).on("click", ".button-drawer-header-dismiss.dropdown-modal-toggle", function () {
    let miniCartModal = document.getElementById("HeaderMiniCart");
    if (miniCartModal) {
        miniCartModal.removeAttribute("open");
    }
    let cartToggle = document.querySelector("a.head-slot-cart-link.dropdown-modal-toggle");
    if (cartToggle) {
        cartToggle.removeAttribute("aria-expanded");
    }
});
// remove the product into cart page and card drawer area
jQuery(document).on('click', '.cart-button-cart-remove_additional_charges', function () {
  var variantId = jQuery(this).attr('data-id');
  var qty = jQuery(this).attr('data-qty');
   if(window.location.pathname == '/cart'){
     jQuery(".cart-ctas button").prop("disabled", true);
     jQuery('.cart-item-loading-overlay-'+variantId).removeClass('hidden')
   } else{
     jQuery(".mini-cart-footer-actions button").prop("disabled", true);
     jQuery('.mini-cart-wrap').addClass('loading');
   }
  updateCart(variantId, qty,'nochange')
});
// Change the product qty into cart page and card drawer area
jQuery(document).on('click', '.cart-quantity-input-button', function () {
    var variantId = jQuery(this).attr('data-id');
      let inputField = this.closest(".quantity-input").querySelector(".cart-quantity-input-field");
      let currentValue = parseInt(inputField.value, 10);
      let minValue = parseInt(inputField.min, 10) || 1;
      if (this.name === "plus") {
          inputField.value = currentValue + 1;
        var qty = currentValue + 1;
         updateCart(variantId, qty,'nochange')
      } else if (this.name === "minus") {         
          inputField.value = currentValue - 1;
        var qty = currentValue - 1;
        updateCart(variantId, qty,'nochange')
      }
       if(window.location.pathname == '/cart'){
         jQuery(".cart-ctas button").prop("disabled", true);
         jQuery('.cart-item-loading-overlay-'+variantId).removeClass('hidden')
       } else{ 
         jQuery(".mini-cart-footer-actions button").prop("disabled", true);
         jQuery('.mini-cart-wrap').addClass('loading');
       }         
 }); 
// Change the product qty into cart page and card drawer area with input field
$(document).on("blur", ".cart-quantity-input-field", function () {
    var variantId = jQuery(this).attr("data-id");
    var last_qty = jQuery(this).attr("data-qty");
    var qty = jQuery(this).val();
  if(last_qty != qty){
    updateCart(variantId, qty, "nochange");
    if (window.location.pathname == "/cart") {
        jQuery(".cart-ctas button").prop("disabled", true);
        jQuery(".cart-item-loading-overlay-" + variantId).removeClass("hidden");
    } else {
        jQuery(".mini-cart-footer-actions button").prop("disabled", true);
        jQuery(".mini-cart-wrap").addClass("loading");
    }
  }
});
jQuery(document).ready(function() {
  if(window.location.pathname == '/cart'){
    getCartProducts();
  }
});
// Get All cart products 
function getCartProducts() {
  fetch('/cart.js', {
    method: 'GET',
    headers: {
        'Content-Type': 'application/json',
    }
  }).then(response => {
        if (!response.ok) {
            throw new Error('Failed to fetch cart data');
        }
        return response.json();
    }).then(cart => {
        var totalcartquantity = 0;
        var specialproductquty = 0;
        var totalcartquantitydrillingcharges = 0;
        var specialproductqutydrilingcharges = 0; 
        // Example: Loop through products in the cart
        cart.items.forEach(item => {
          if(item['id'] == '43976061780108'){
            specialproductquty = item.quantity;
          }            
          if(item.properties['_additional_charges']){
            //console.log('Quantity:', item.quantity)
            totalcartquantity = totalcartquantity+item.quantity;
          }

          // For Drilling Charges
          if(item['id'] == '44403212189836'){
            specialproductqutydrilingcharges = item.quantity;
          }            
          if(item.properties['_drilling_charges']){
            totalcartquantitydrillingcharges = totalcartquantitydrillingcharges+item.quantity;
          }
        });
    // console.log('=====',totalcartquantity,'====specialproductquty===',specialproductquty)
     // console.log('===totalcartquantity===',totalcartquantity)
    console.log('=====',cart.items.length)
    if(cart.items.length > 0){
      if(specialproductquty == 0 && totalcartquantity > 0){
        const variantId = '43976061780108';
        SpecialProductAddToCart(variantId, totalcartquantity)
      } else if(totalcartquantity > 0 || totalcartquantity != specialproductquty){
        console.log('update');
         const variantId = '43976061780108';
         updateCart(variantId, totalcartquantity,'change')
      } else if (totalcartquantity == 0 && specialproductquty > 0){
          const variantId = '43976061780108';
          updateCart(variantId, totalcartquantity,'change')
      }

      // For Drilling Charges
      if(specialproductqutydrilingcharges == 0 && totalcartquantitydrillingcharges > 0){
        const variantId = '44403212189836';
        SpecialProductAddToCart(variantId, totalcartquantitydrillingcharges)
      } else if(totalcartquantitydrillingcharges > 0 || totalcartquantitydrillingcharges != specialproductqutydrilingcharges){
        console.log('update');
         const variantId = '44403212189836';
         updateCart(variantId, totalcartquantitydrillingcharges,'change')
      } else if (totalcartquantitydrillingcharges == 0 && specialproductqutydrilingcharges > 0){
          const variantId = '44403212189836';
          updateCart(variantId, totalcartquantitydrillingcharges,'change')
      }
    }
    })
    .catch(error => {
        console.error('Error:', error);
    });
}
function SpecialProductAddToCart (variantId, totalcartquantity){
  if(totalcartquantity > 0){
    var data = {
             quantity: totalcartquantity, 
             id: variantId,
        };
     $.ajax({
          url: "/cart/add.js",
          type: "POST",
          data: JSON.stringify(data),
          contentType: 'application/json',
          dataType: 'json',
          success: function(data){
          if(window.location.pathname == '/cart'){
            jQuery('.cart-item-loading-overlay-'.variantId).addClass('hidden')
             updateCartPage();
          } else{
            updatecartMiniCart();
          }
           jQuery('.mini-cart-wrap').removeClass('loading'); 
          }
      });
  }
  
}
// Update the cart Blank wheels product into cart
function updateCart(variantId, quantity, changevalue) {
    fetch('/cart/update.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            updates: {
                [variantId]: quantity
            }
        })
    })
    .then(response => {
        if (!response.ok) {
            throw new Error('Failed to update cart');
        }
        return response.json();
    })
    .then(cart => {
       // console.log('Cart updated:');
      if(changevalue == 'change'){
          if(window.location.pathname == '/cart'){
            jQuery('.cart-item-loading-overlay-'.variantId).addClass('hidden')
             updateCartPage();
          } else{
            updatecartMiniCart();
          }
          jQuery('.mini-cart-wrap').removeClass('loading');
        } else{
          getCartProducts();
        }
        
    })
    .catch(error => {
        console.error('Error:', error);
    });
}

function updateCartPage() {
   fetch('/cart.js')
    .then(response => response.json()) // Parse JSON response
    .then(cart => {
        // Update cart item count
        document.querySelector("span.head-slot-cart-link-quantity").innerText = cart.item_count;
    })
    .catch(error => console.error("Error updating cart count:", error));
  
    fetch(window.location.href)
    .then(response => response.text())
    .then(html => {
        let parser = new DOMParser();
        let doc = parser.parseFromString(html, "text/html");

        // let newCartPage = doc.querySelector("#cart-container"); // Adjust selector as needed
        // let currentCartPage = document.querySelector("#cart-container");

        let newCartPage = doc.querySelector("#MainContent"); // Adjust selector as needed
        let currentCartPage = document.querySelector("#MainContent");

       // let newCartPageFooter = doc.querySelector("#main-cart-footer"); // Adjust selector as needed
       // let currentCartPageFooter = document.querySelector("#main-cart-footer");

      

        if (newCartPage && currentCartPage) {
            currentCartPage.innerHTML = newCartPage.innerHTML;
        }
        // if (newCartPageFooter && currentCartPageFooter) {
        //     currentCartPageFooter.innerHTML = newCartPageFooter.innerHTML;
        // }
    })
    .catch(error => console.error("Error updating cart page:", error));
}
function updatecartMiniCart() {
   fetch('/cart.js')
    .then(response => response.json()) // Parse JSON response
    .then(cart => {
        // Update cart item count
        document.querySelector("span.head-slot-cart-link-quantity").innerText = cart.item_count;
    })
    .catch(error => console.error("Error updating cart count:", error));

    fetch(window.location.href)
        .then(response => response.text())
        .then(html => {
            let parser = new DOMParser();
            let doc = parser.parseFromString(html, "text/html");
            let newMiniCart = doc.querySelector(".mini-cart-wrap");
            let currentMiniCart = document.querySelector(".mini-cart-wrap");
            if (newMiniCart && currentMiniCart) {
                currentMiniCart.innerHTML = newMiniCart.innerHTML;
            }
        })
        .catch(error => console.error("Error updating mini-cart:", error));
}
